import React, { useEffect } from 'react';
import './Ordersuccess.css';
import { useLocation, Link } from 'react-router-dom';

function Ordersuccess() {
    const { state } = useLocation();
    const order = state?.order;

    useEffect(() => { window.scrollTo(0, 0); }, []);

    if (!order) {
        return (
            <div className="main-ordersuccess">
                <div className="container py-5 text-center">
                    <p className="mb-2 text-success" style={{ fontSize: '70px', lineHeight: 1 }}>
                        <i className="fi fi-ss-check-circle"></i>
                    </p>
                    <h2 className="body-font-bold">Order Placed Successfully</h2>
                    <p className="text-muted">Your order has been placed.</p>
                    <div className="d-flex justify-content-center gap-3 mt-4">
                        <Link to="/" className="btn btn-outline-brand-secondary px-4 py-2">Go Home</Link>
                        <Link to="/orders" className="btn btn-brand-secondary px-4 py-2">My Orders</Link>
                    </div>
                </div>
            </div>
        );
    }

    const rawTotal = order.products?.reduce((t, p) => t + p.price * p.quantity, 0) || 0;
    const discount = order.discount || 0;
    const finalTotal = rawTotal - discount;

    return (
        <div className="main-ordersuccess">
            <div className="container py-4">

                {/* Success header */}
                <div className="text-center py-4">
                    <p className="mb-2 text-success" style={{ fontSize: '72px', lineHeight: 1 }}>
                        <i className="fi fi-ss-check-circle"></i>
                    </p>
                    <h2 className="body-font-bold fs-2 mb-1">Order Placed Successfully!</h2>
                    <p className="text-muted fs-sm mb-0">
                        Order ID: <span className="body-font-medium text-dark">{order.orderid}</span>
                    </p>
                </div>

                <div className="row justify-content-center mt-2">
                    <div className="col-md-7 col-lg-6">

                        {/* Products ordered */}
                        <div className="border rounded-brand p-3 mb-3 bg-white">
                            <h5 className="body-font-semibold mb-3 fs-6">Products Ordered</h5>
                            {order.products?.map((p, i) => (
                                <div key={i} className={`d-flex justify-content-between align-items-start pb-2 mb-2 ${i < order.products.length - 1 ? 'border-bottom' : ''}`}>
                                    <div style={{ maxWidth: '75%' }}>
                                        <p className="mb-0 body-font-medium lh-sm">{p.proname}</p>
                                        <p className="mb-0 text-muted fs-sm">Qty: {p.quantity}</p>
                                    </div>
                                    <p className="mb-0 body-font-semibold">₹{p.price * p.quantity}</p>
                                </div>
                            ))}

                            {/* Price summary */}
                            <div className="mt-2 pt-2 border-top">
                                {discount > 0 && (
                                    <>
                                        <div className="d-flex justify-content-between text-muted fs-sm mb-1">
                                            <span>Subtotal</span>
                                            <span>₹{rawTotal}</span>
                                        </div>
                                        <div className="d-flex justify-content-between text-success fs-sm mb-1">
                                            <span>Coupon ({order.coupon})</span>
                                            <span>-₹{discount}</span>
                                        </div>
                                    </>
                                )}
                                <div className="d-flex justify-content-between pt-2 border-top mt-1">
                                    <span className="body-font-bold">
                                        {order.paymetdetails ? 'Amount Paid' : 'To Pay (COD)'}
                                    </span>
                                    <span className="body-font-bold text-success fs-5">
                                        ₹{order.paymetdetails ? order.paymetdetails.amount : finalTotal}
                                    </span>
                                </div>
                                {order.paymetdetails && (
                                    <p className="mb-0 text-success fs-sm text-end body-font-medium mt-1">
                                        <i className="fi fi-ss-check me-1"></i>Paid Online
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* Delivery & contact details */}
                        <div className="border rounded-brand p-3 mb-3 bg-white">
                            <h5 className="body-font-semibold mb-3 fs-6">Delivery Details</h5>
                            <div className="row g-3">
                                <div className="col-6">
                                    <p className="mb-1 text-muted fs-sm">Name</p>
                                    <p className="mb-0 body-font-medium">{order.address?.name || '—'}</p>
                                </div>
                                <div className="col-6">
                                    <p className="mb-1 text-muted fs-sm">Phone</p>
                                    <p className="mb-0 body-font-medium">{order.number || '—'}</p>
                                </div>
                                {order.email && (
                                    <div className="col-12">
                                        <p className="mb-1 text-muted fs-sm">Email</p>
                                        <p className="mb-0 body-font-medium">{order.email}</p>
                                    </div>
                                )}
                                <div className="col-12">
                                    <p className="mb-1 text-muted fs-sm">Address</p>
                                    <p className="mb-0 body-font-medium lh-sm">{order.address?.address || '—'}</p>
                                </div>
                                <div className="col-6">
                                    <p className="mb-1 text-muted fs-sm">City</p>
                                    <p className="mb-0 body-font-medium">{order.address?.city || '—'}</p>
                                </div>
                                <div className="col-6">
                                    <p className="mb-1 text-muted fs-sm">State</p>
                                    <p className="mb-0 body-font-medium">{order.address?.state || '—'}</p>
                                </div>
                                <div className="col-6">
                                    <p className="mb-1 text-muted fs-sm">Pincode</p>
                                    <p className="mb-0 body-font-medium">{order.address?.pincode || '—'}</p>
                                </div>
                                <div className="col-6">
                                    <p className="mb-1 text-muted fs-sm">Country</p>
                                    <p className="mb-0 body-font-medium">{order.address?.country || 'India'}</p>
                                </div>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="d-flex gap-2 mb-5">
                            <Link to="/" className="btn btn-outline-brand-secondary w-50 py-2">Go Home</Link>
                            <Link to="/orders" className="btn btn-brand-secondary w-50 py-2">My Orders</Link>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Ordersuccess;
